import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type FernieQuickBooksLinksQueryVariables = Types.Exact<{
  input: Types.FernieQuickBooksLinksInput;
}>;


export type FernieQuickBooksLinksQuery = { __typename?: 'Query', fernieQuickBooksLinks: { __typename?: 'FernieQuickBooksLinksPayload', totalCount: number, endCursor?: string | null, rows: Array<{ __typename?: 'FernieQuickBooksLinkRow', customerId: string, customerName: string, customerDetail?: string | null, candidates: Array<{ __typename?: 'FernieAccountingCandidate', id: string, label: string, detail?: string | null }> }>, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type FernieStripeTaxCodeCandidatesQueryVariables = Types.Exact<{
  input: Types.FernieStripeTaxCodeCandidatesInput;
}>;


export type FernieStripeTaxCodeCandidatesQuery = { __typename?: 'Query', fernieStripeTaxCodeCandidates: { __typename?: 'FernieStripeTaxCodeCandidatesPayload', candidates: Array<{ __typename?: 'FernieAccountingCandidate', id: string, label: string, detail?: string | null }>, errors?: Array<{ __typename?: 'Error', message: string }> | null } };

export type QuickBooksLinkJobQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type QuickBooksLinkJobQuery = { __typename?: 'Query', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number } | null, backgroundJobItems: Array<{ __typename?: 'BackgroundJobItem', itemId: string, label: string, state: Types.BackgroundJobItemState, error?: string | null, resultIds: Array<string> }> };


export const FernieQuickBooksLinksDocument = new TypedDocumentString(`
    query FernieQuickBooksLinks($input: FernieQuickBooksLinksInput!) {
  fernieQuickBooksLinks(input: $input) {
    rows {
      customerId
      customerName
      customerDetail
      candidates {
        id
        label
        detail
      }
    }
    totalCount
    endCursor
    errors {
      message
    }
  }
}
    `);
export const FernieStripeTaxCodeCandidatesDocument = new TypedDocumentString(`
    query FernieStripeTaxCodeCandidates($input: FernieStripeTaxCodeCandidatesInput!) {
  fernieStripeTaxCodeCandidates(input: $input) {
    candidates {
      id
      label
      detail
    }
    errors {
      message
    }
  }
}
    `);
export const QuickBooksLinkJobDocument = new TypedDocumentString(`
    query QuickBooksLinkJob($jobId: String!) {
  backgroundJob(jobId: $jobId) {
    jobId
    status
    total
    done
    failed
  }
  backgroundJobItems(jobId: $jobId, take: 100) {
    itemId
    label
    state
    error
    resultIds
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    FernieQuickBooksLinks: build.query<FernieQuickBooksLinksQuery, FernieQuickBooksLinksQueryVariables>({
      query: (variables) => ({ document: FernieQuickBooksLinksDocument, variables })
    }),
    FernieStripeTaxCodeCandidates: build.query<FernieStripeTaxCodeCandidatesQuery, FernieStripeTaxCodeCandidatesQueryVariables>({
      query: (variables) => ({ document: FernieStripeTaxCodeCandidatesDocument, variables })
    }),
    QuickBooksLinkJob: build.query<QuickBooksLinkJobQuery, QuickBooksLinkJobQueryVariables>({
      query: (variables) => ({ document: QuickBooksLinkJobDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useFernieQuickBooksLinksQuery, useLazyFernieQuickBooksLinksQuery, useFernieStripeTaxCodeCandidatesQuery, useLazyFernieStripeTaxCodeCandidatesQuery, useQuickBooksLinkJobQuery, useLazyQuickBooksLinkJobQuery } = injectedRtkApi;
